import { render, staticRenderFns } from "./bankruptcy.vue?vue&type=template&id=2d518694&scoped=true"
import script from "./bankruptcy.vue?vue&type=script&lang=js"
export * from "./bankruptcy.vue?vue&type=script&lang=js"
import style0 from "./bankruptcy.vue?vue&type=style&index=0&id=2d518694&prod&lang=scss&module=true"
import style1 from "./bankruptcy.vue?vue&type=style&index=1&id=2d518694&prod&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2d518694",
  null
  
)

export default component.exports